<div class="header-section">
    <div class="section-wrapper is-header"
    [class.no-margin]="searchViewOptions().periodDefinitionType === periodType.Sold"
    [class.in-market]="searchViewOptions().periodDefinitionType === periodType.InMarket">
        <div class="centered-row-wrapper">
            <div>{{ computedTimePeriod().fromDate | date: "shortDate" }}</div>
            <div class="left-arrow"></div>
            <div
                class="period-type-icon"
                [class.registered-icon]="searchViewOptions().periodDefinitionType === periodType.Registered"
                [class.sold-icon]="searchViewOptions().periodDefinitionType === periodType.Sold"
                [class.inmarket-icon]="searchViewOptions().periodDefinitionType === periodType.InMarket"                
            ></div>
            <div class="right-arrow"></div>
            <div>{{ computedTimePeriod().toDate | date: "shortDate" }}</div>
            <div class="info-icon" (click)="showInformation = !showInformation" (clickOutside)="showInformation = false">
                <ev_tooltip
                    [visible]="showInformation"
                    [title]="searchViewOptions().periodDefinitionType === periodType.Registered ? 'Registrert' : searchViewOptions().periodDefinitionType === periodType.Sold ? 'Solgt' : 'I markedet'"
                    [zIndex]="2"
                    [right]="-16"
                    [top]="28"
                    [arrowAlignRight]="16"
                    [arrow]="'top'"
                    (close)="showInformation = false"
                    [width]="360"
                >
                    <market-statistics-helper [searchViewOptions]="searchViewOptions()"></market-statistics-helper>
                </ev_tooltip>
            </div>
        </div>
        <div class="flex-coloumn" [class.count-separator]="searchViewOptions().periodDefinitionType !== periodType.InMarket">
            @if (searchViewOptions().periodDefinitionType === periodType.Registered) {
                <div class="uppercase-text primary-color">Registrert</div>
            }
            @else if (searchViewOptions().periodDefinitionType === periodType.Sold) {
                <div class="uppercase-text primary-color">Solgt</div>
            }
            @else if (searchViewOptions().periodDefinitionType === periodType.InMarket) {
                <div class="uppercase-text primary-color">I markedet</div>
            }
            <div class="uppercase-text secondary-color">i perioden</div>
            <div class="extra-big-number">{{ statistics().numberOfEstates | thousandize }}</div>
        </div>
    </div>
    @if(searchViewOptions().periodDefinitionType !== periodType.Sold) {
        <statistics-priceassumption [statistics]="statistics()" [showDetails]="true" [isHeader]="true" [searchViewOptions]="searchViewOptions()"></statistics-priceassumption>
        <statistics-sold [statistics]="statistics()" [showDetails]="true" [isHeader]="true" [searchViewOptions]="searchViewOptions()"></statistics-sold>
    }
    @if(searchViewOptions().periodDefinitionType === periodType.Sold) {
        <statistics-sold [statistics]="statistics()" [showDetails]="true" [isHeader]="true" [searchViewOptions]="searchViewOptions()"></statistics-sold>
        <statistics-priceassumption [statistics]="statistics()" [showDetails]="true" [isHeader]="true" [searchViewOptions]="searchViewOptions()"></statistics-priceassumption>
    }
</div>
